<template>
    <div class="betContent">
        <template v-if="!closeBetContent">
            <span v-if="row.content_type == 29" class="text-ia_esport">{{ row["sport_name"] }}</span>
            <span v-else class="text-saba">{{ row["sport_name"] }}</span>
            <br />
            <template v-if="Array.isArray(row['competition'])">
                <template v-for="(item,index) in row['competition']" >
                    <span  v-if="index==0" style="color: black" :key="'black-' + index">[{{ item }}]</span>
                    <span  v-else style="color: gray" :key="'gray-' + index">({{ item }})</span><br :key='index'>
                </template>
            </template>
            <template  v-else-if="row.competition != '' && row.competition != null">
                <span style="color: black">[{{ row['competition'] }}]</span><br>
            </template>

            <!-- 鬥雞被歸類為體育 有獨有的顯示 eventId -->
            <template  v-if="row.eventId != '' && row.eventId != null">
                <span style="color: black">[{{ row['eventId'] }}]</span><br>
            </template>

            <template  v-if="row.team1 && row.team1 != ''">
                <span  ><i class="tg-icon tg-icon-grayball"></i>{{ row["team1"] }}</span><br>
            </template>
            
            <template  v-if="row.team2 && row.team2 != ''">
                <span  ><i class="tg-icon tg-icon-grayball"></i>{{ row["team2"] }}</span><br>
            </template>
        </template>

        <template v-if="!closeOdd">
            <template v-if="showBr">
                <el-row type="flex" justify="center" align="middle">
                    <i class="tg-icon tg-icon-game" v-if="!closeOddIcon"></i>
                    <span class="text-green"
                        >{{ row["market"] }} &nbsp; {{ row["selection"] }}
                    </span>
                </el-row>
                <div v-if="row.content_type == 5">
                    <template v-for="(item,index) in row.odds_info.split(',')">
                        <template v-for="(value,i) in item.split(':')" >
                            <span v-if="i == 0" class="text-green" :key='i'> {{ $t("enum.saba.bet_type["+row.bet_type+"]["+value+"]") }}</span>
                            <span v-if="i == 0" :key='i'>@</span>
                            <span v-if="i == 1" class="text-red" :key='i'>{{ value }}</span>
                        </template><br  :key='index'>
                    </template>
                </div>
                <div v-else>
                    <span class="text-green">{{ row["profit_type_name"] }}</span>
                    <span>@</span>
                    <span v-if="row.content_type == 2" class="text-red">{{ profitWtihNoIcon }}</span>
                    <span v-else class="text-red">{{ profitWtihNoIcon }}%</span>
                    <span v-if="row.isLive == '1'">({{ $t('component.label.grounder') /*滾球*/ }})</span>
                </div>
            </template>
            <template v-else>
                <el-row type="flex" justify="center" align="middle">
                    <i class="tg-icon tg-icon-game" v-if="!closeOddIcon"></i>
                    <span class="text-green"
                        >{{ row["market"] }} {{ row["selection"] }}</span
                    >
                </el-row>
                <template v-if="row.content_type == 5" >
                    <template v-for="(item,index) in row.odds_info.split(',')">
                        <template v-for="(value,i) in item.split(':')" >
                            <span v-if="i == 0" class="text-green" :key='i'> {{ $t("enum.saba.bet_type["+row.bet_type+"]["+value+"]") }}</span>
                            <span v-if="i == 0" :key='i'>@</span>
                            <span v-if="i == 1" class="text-red" :key='i'> {{ value }}</span>
                        </template><br  :key='index'>
                    </template>
                </template>
                
                <template v-else >
                    <span class="text-green">{{ row["profit_type_name"] }}</span>
                    <span>@</span>
                    <span v-if="row.content_type == 2" class="text-red">{{ profitWtihNoIcon }}</span>
                    <span v-else class="text-red">{{ profitWtihNoIcon }}%</span>
                    <span v-if="row.isLive == '1'">({{ $t('component.label.grounder') /*滾球*/ }})</span>
                </template>
                
            </template>
        </template>
    </div>
</template>

<script>
import formatter from "@/utils/formatter";

export default {
    props: {
        row: Object,
        closeBetContent: Boolean,
        closeOddIcon:Boolean,
        closeOdd: Boolean,
    },
    computed: {
        profit() {
            return formatter.format(this.row["profit"], "percent");
        },
        profitWtihNoIcon() {
            return formatter.format(this.row["profit"], "percentWithNoIcon");
        },
        showBr() {
            return this.row['selection'] && this.row['selection'].length > 6;
        }
    },
};
</script>
